import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";

import { previewReportCancelToken } from "../../services/reportService";
import SkeletonLoadFormData from "../../loaders/SkeletonLoadFormData";

/**
 * Full-page Power BI report preview for a saved report id.
 * @returns {JSX.Element} Embedded Power BI report view.
 */
const ReportView = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [powerBIConfig, setPowerBIConfig] = useState(null);

  useEffect(() => {
    const cancelTokenSource = axios.CancelToken.source();

    const handlePreviewReport = async () => {
      setLoading(true);

      try {
        const res = await previewReportCancelToken(
          { id },
          cancelTokenSource.token
        );

        if (res.status === 200 || res.data?.status) {
          const data = res.data?.data || res.data;
          setPowerBIConfig({
            type: "report",
            id: data.reportId,
            embedUrl: data.embedUrl,
            accessToken: data.embedToken,
            tokenType: models.TokenType.Embed,
            settings: {
              panes: {
                filters: {
                  expanded: false,
                  visible: false,
                },
              },
              navContentPaneEnabled: true,
            },
          });
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          setPowerBIConfig(null);
        }
      } finally {
        setLoading(false);
      }
    };

    handlePreviewReport();

    return () => {
      cancelTokenSource.cancel("ReportView unmounted or report id changed");
    };
  }, [id]);

  return (
    <div className="card card-body-inr">
      <div>
        {!loading && powerBIConfig ? (
          <PowerBIEmbed
            embedConfig={powerBIConfig}
            cssClassName="powerbi-container"
          />
        ) : (
          <SkeletonLoadFormData />
        )}
      </div>
    </div>
  );
};

export default ReportView;
